import { Dialog, TextV2 } from '@insights-ltd/design-library/components';
import {
  DfcInviteeResponse,
  EventResponseWithChapters,
  InviteeResponse,
} from 'api';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

type AddLearnersToTeamModalProps = {
  invitees: InviteeResponse[] | DfcInviteeResponse[];
  event: EventResponseWithChapters;
  isAddToTeamOpen: boolean;
  setIsAddToTeamOpen: (isOpen: boolean) => void;
};

export const AddLearnersToTeamModal = ({
  invitees,
  event,
  isAddToTeamOpen,
  setIsAddToTeamOpen,
}: AddLearnersToTeamModalProps) => {
  const { t } = useTranslation();

  const inviteesToAdd = invitees.filter(
    (invitee) =>
      invitee.status === 'READY_TO_PURCHASE' ||
      invitee.status === 'PROFILE_GENERATED',
  );
  const navigate = useNavigate();

  return (
    <Dialog
      title={t('ui.event-management.add-to-team.modal.title')}
      open={isAddToTeamOpen}
      onClose={() => setIsAddToTeamOpen(false)}
      onSubmit={() =>
        // change to new route to create team when available
        navigate('/teams/add-to-team', {
          state: {
            inviteesToAdd,
            organisation: event.organisation,
            event: { id: event.id, name: event.name },
          },
        })
      }
      content={
        <>
          <TextV2 component="span" color="textSecondary">
            {t('ui.event-management.add-to-team.modal.info')}
          </TextV2>
          <TextV2 component="span" color="textSecondary">
            <ul>
              <li>
                {t(
                  'ui.event-management.events.invitee.status.ready-to-purchase',
                )}
              </li>
              <li>
                {t('ui.event-management.events.invitee.status.profile-created')}
              </li>
            </ul>
          </TextV2>
          <TextV2 component="span" color="textSecondary">
            <Trans
              i18nKey="ui.event-management.add-to-team.modal.info.confirmation"
              t={t}
              values={{ count: inviteesToAdd.length }}
              components={{
                bold: <TextV2 component="span" variant="bodyBold" />,
              }}
            />
          </TextV2>
        </>
      }
      primaryButtonText={t(
        'ui.event-management.manage-learners.add-to-team.modal.confirm.button',
        {
          count: inviteesToAdd.length,
        },
      )}
      disablePrimaryButton={inviteesToAdd.length === 0}
      secondaryButtonText={t('ui.event-management.cancel')}
    />
  );
};

export const getPreviousProfileInvitees = (
  invitees: InviteeResponse[],
): InviteeResponse[] => {
  return invitees.filter(
    (invitee) =>
      invitee.profile?.status === 'AVAILABLE_FOR_REUSE' &&
      invitee.profile.reusePreference === 'NONE',
  );
};
